import $ from "jquery";

let video;
const video_btns = document.querySelectorAll('.video__btn');

video_btns.forEach(btn => {
    const videoId = btn.dataset.video;

    video = document.getElementById(videoId);

    if ( video ) {
        // Cache le bouton une fois la vidéo lancée
        btn.addEventListener('click', () => {
            video.play();
            btn.style.display = 'none';
            video.controls = true;
        });

        // Réaffiche le btn si la vidéo est en pause (optionnel)
        video.addEventListener('pause', () => {
           btn.style.display = 'block';
        });
    }
})
